import { PAGE_SIZE } from '../lib/api'

interface Props {
  page: number
  total: number
  onChange: (p: number) => void
  /** 每页大小(必须与后端 PAGE 常量一致),默认 PAGE_SIZE=20 */
  pageSize?: number
}

export function Pager({ page, total, onChange, pageSize = PAGE_SIZE }: Props) {
  const max = Math.max(1, Math.ceil(total / pageSize))
  if (max <= 1) return null
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', marginTop: '.5rem', fontSize: 'var(--fs-capt)', color: 'var(--ink2)' }}>
      <button onClick={() => onChange(page - 1)} disabled={page <= 1} className="btn-ghost" style={{ padding: '.2rem .5rem', fontSize: 'var(--fs-capt)' }}>上一页</button>
      <span>{page} / {max} · 共 {total} 条</span>
      <button onClick={() => onChange(page + 1)} disabled={page >= max} className="btn-ghost" style={{ padding: '.2rem .5rem', fontSize: 'var(--fs-capt)' }}>下一页</button>
    </div>
  )
}